module.exports = __webpack_public_path__ + "img/caselist21.cab349a9.jpg";